var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":'Attendance'}}),_vm._v(" "),_c('div',{staticClass:"mb-primary"},[_c('div',{staticClass:"card p-primary border-0"},[_c('teacher-pages-attendance-form-wizard',{attrs:{"tabs":_vm.computedTabs}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }